<div class="container">
  <div class="left">
    <div class="icon-wrapper">
      <mat-icon
        class="icon"
        svgIcon="assistant"
      ></mat-icon>
    </div>
    <div class="name-wrapper">
      <div class="name">{{ PRODUCT_NAME }}</div>
      <div class="title">
        <button
          class="blank-button help"
          (click)="onHelp()"
          merriNoFocusLink
        >
          <mat-icon
            class="help-icon"
            svgIcon="chat"
          ></mat-icon
          ><span class="help-text">Help</span>
        </button>
      </div>
    </div>
  </div>
  <div class="right">
    <button
      class="blank-button minimize"
      (click)="onMinimize()"
      matRipple
      merriNoFocusLink
    >
      <mat-icon svgIcon="minus"></mat-icon>
    </button>
  </div>
</div>
